// App.js
import React from "react";
import { Route, Switch, BrowserRouter as Router } from "react-router-dom";
import AdminApp from './AdminApp';
import SigningPage from './components/signing/SigningPage';
import ProcessingPage from './components/signing/ProcessingPage';
import CompletePage from './components/signing/CompletePage';
import RejectedPage from './components/signing/RejectedPage';
import { ProtectedRoute } from './utils/ProtectedRoutes';
import Onboard from "../src/components/onboard/onboard";

export default function App() {
  return (
    <Router>
      <Switch>
        {/* Public routes for e-sign flow */}
        <Route exact path="/e-sign/sign/:token" component={SigningPage} />
        <Route exact path="/e-sign/processing/:documentId" component={ProcessingPage} />
        <Route exact path="/e-sign/complete" component={CompletePage} />
        <Route exact path="/e-sign/rejected" component={RejectedPage} />
        
        {/* Authentication routes */}
        <Route exact path="/login" component={Onboard} />
        <ProtectedRoute exact path="/*" component={AdminApp} />
      </Switch>
    </Router>
  );
}